import { render, staticRenderFns } from "./VandP.vue?vue&type=template&id=5df1a8aa&scoped=true"
import script from "./VandP.vue?vue&type=script&lang=js"
export * from "./VandP.vue?vue&type=script&lang=js"
import style0 from "./VandP.vue?vue&type=style&index=0&id=5df1a8aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df1a8aa",
  null
  
)

export default component.exports